<template>
  <q-card class="gos-card">

    <q-card-section class="gos-header">

      <div class="text-h6">
        Запись на прием
      </div>

      <div class="text-caption">
        Выберите дату и время
      </div>

      <div v-if="appointmentMessage" class="text-positive">
        {{ appointmentMessage }}
      </div>

    </q-card-section>

    <q-card-section class="row q-col-gutter-md">

      <q-date
        minimal
        v-model="appointmentDate"
        :options="availableDays"
      />

      <div v-if="appointmentDate">

        <q-btn-toggle
          v-model="appointmentTime"
          :options="availableTimes"
          toggle-color="primary"
        />

        <q-input
          v-model="phone"
          label="Телефон"
          mask="+7 (###) ### - ####"
          type="tel"
        >
          <template #prepend>
            <q-icon name="phone"/>
          </template>
        </q-input>

        <q-btn
          class="gos-btn"
          color="primary"
          icon="event_available"
          label="Записаться"
          :loading="sending"
          :disable="!appointmentTime"
          @click="createAppointment"
        />

      </div>

    </q-card-section>

  </q-card>
</template>

<script lang="ts">
import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { date } from 'quasar';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
import { useAuthStore } from '~store/auth/authModule';
import { useMainStore } from '@/store';

import { Slot } from '~store/ecohospital/types';

export default { name: 'AppointmentPage' };
</script>

<script setup lang="ts">
const ecoStore = useEcoHospitalStore();
const authStore = useAuthStore();

const { user } = storeToRefs(authStore);

const appointmentDate = ref<string | null>(null);
const appointmentTime = ref('');
const calendar = ref<Slot[]>([]);
const phone = ref('');
const sending = ref(false);
const appointmentMessage = ref('');

onMounted(async () => {
  if (!user.value?.show_appointment) return;

  try {
    const availableSlots = await ecoStore.getAppointmenCalendar();

    if (availableSlots.length) calendar.value = availableSlots;

    if (user.value?.tel) phone.value = user.value.tel;
  } catch (err) {
    console.error(err);
  }
});

const availableDays = computed(() => calendar.value.map((i) => date.formatDate(i.date, 'YYYY/MM/DD')));

const availableTimes = computed(() => {
  const calendarIndex = availableDays.value.findIndex(
    (i) => i === appointmentDate.value,
  );

  if (calendarIndex > -1) {
    return calendar.value[calendarIndex].times
      .split(',')
      .map((i) => ({
        label: i.split(':').slice(0, 2).join(':'),
        value: i,
      }));
  }

  return [];
});

const createAppointment = async () => {
  if (!appointmentTime.value) {
    useMainStore().showMessage('Укажите желаемое время приема!');
    return;
  }

  if (phone.value.includes('_')) {
    useMainStore().showMessage('Неверный формат номера телефона!');
    return;
  }

  const cleaned = phone.value.replace(/\D/g, '');

  const params = {

    date: date.formatDate(
      appointmentDate.value ?? '',
      'YYYY-MM-DD',
    ),

    time: appointmentTime.value.trim(),

    tel: `+${cleaned}`,

  };

  try {
    sending.value = true;

    const [appointment] = await ecoStore.createAppointment(params);

    if (appointment.err_text.includes('Ваша заявка принята')) {
      appointmentMessage.value = appointment.err_text;

      const busySlotIndex = availableTimes.value.findIndex(
        (i) => i.value === appointmentTime.value,
      );

      if (busySlotIndex > -1) availableTimes.value.splice(busySlotIndex, 1);
    }
  } catch (err) {
    console.error(err);
  } finally {
    sending.value = false;
  }
};
</script>

<style>
.gos-card {
  border-radius: 16px;
  max-width: 720px;
  margin: auto;

}

.gos-header {
  text-align: center;
  padding: 20px;

}

.gos-btn {
  width: 100%;
  margin-top: 20px;
  height: 48px;
  font-size: 16px;

}
</style>
